/**
 * Hook de login: mutación sobre `POST /auth/login`.
 *
 * En éxito, el navegador queda con las cookies httpOnly y se invalida la query
 * de identidad (`AUTH_ME_QUERY_KEY`) para que el `AuthProvider` re-hidrate el
 * contexto desde `/auth/me`. El error (credenciales inválidas → `ApiError` 401)
 * se expone vía `mutation.error` para que la pantalla lo muestre.
 */
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { AUTH_ME_QUERY_KEY } from "@/lib/auth";

import { login } from "../api";
import type { LoginValues } from "../schemas";
import type { LoginResponse } from "../types";

export function useLogin() {
  const queryClient = useQueryClient();
  return useMutation<LoginResponse, Error, LoginValues>({
    mutationFn: login,
    onSuccess: async () => {
      // Re-hidrata la identidad con la sesión ya establecida (cookies puestas).
      // `refetchQueries` (no `invalidateQueries`) fuerza el fetch aunque la query
      // de `/auth/me` viniera de un 401 (estado de error): tras autenticar hay
      // que volver a pedirla sí o sí para poblar el contexto.
      await queryClient.refetchQueries({ queryKey: AUTH_ME_QUERY_KEY });
    },
  });
}
